import {
  INSURANCE_REFERRAL_FETCH,
  INSURANCE_REFERRAL_URL_FETCH,
  INSURANCE_REFERRAL_WITH_QUOTE_FETCH,
  INSURANCE_QUOTE_FETCH,
  INSURANCE_CUSTOMER_CONSENT_FETCH,
  INSURANCE_PROFILE_FETCH,
  INSURANCE_PROGRESSIVE_RC1_QUOTE_FETCH,
  INSURANCE_POLICY_FETCH,
  SUPPRESS_QUOTE,
  UNSUPPORTED_DOCUMENT_SELECTED,
  RESET_UNSUPPORTED_DOCUMENT_SELECTED,
  TOGGLE_SHOW_SAMPLE_DOCUMENTS,
  INSURANCE_VALIDATE_POI
} from './action-types';
import * as operations from './operations';

const insuranceState = {
  referral: null,
  progressiveQuote: {
    loading: false,
    hasErrors: false,
    partnerUrl: '',
    rates: []
  },
  policyInformation: {
    loading: false,
    status: null
  },
  insuranceRootQuote: null,
  quoteSuppression: {
    enabled: false,
    eligible: false
  },
  rootQuoteIsLoading: false,
  rootQuoteFetchFailed: false,
  customerConsent: [],
  insuranceProfile: {},
  showSampleDocs: false,
  poiValidation: {
    loading: false,
    isSatisfied: false,
    validationErrors: {
      errorMessages: [],
      duplicateErrors: []
    },
    error: null
  },
  fileSelectionStatus: {
    isValid: true,
    errorMessage: null
  }
};

// eslint-disable-next-line @typescript-eslint/default-param-last
export default function reducer(state = insuranceState, action) {
  const { type, payload } = action;

  switch (type) {
    case SUPPRESS_QUOTE:
      return {
        ...state,
        quoteSuppression: payload
      };

    case `${INSURANCE_REFERRAL_FETCH}_LOADING`:
    case `${INSURANCE_REFERRAL_URL_FETCH}_LOADING`:
      return {
        ...state,
        isReferralLoading: true
      };

    case `${INSURANCE_REFERRAL_FETCH}_SUCCESS`:
    case `${INSURANCE_REFERRAL_URL_FETCH}_SUCCESS`:
      return {
        ...state,
        referral: payload
          ? {
              ...state.referral,
              ...payload
            }
          : null,
        isReferralLoading: false
      };

    case `${INSURANCE_REFERRAL_FETCH}_ERROR`:
    case `${INSURANCE_REFERRAL_URL_FETCH}_ERROR`:
      return {
        ...state,
        isReferralLoading: false
      };

    case `${INSURANCE_REFERRAL_WITH_QUOTE_FETCH}_LOADING`:
      return {
        ...state,
        isReferralQuoteLoading: true
      };

    case `${INSURANCE_REFERRAL_WITH_QUOTE_FETCH}_SUCCESS`:
      return {
        ...state,
        referral: {
          ...state.referral,
          ...payload
        },
        isReferralQuoteLoading: false
      };

    case `${INSURANCE_REFERRAL_WITH_QUOTE_FETCH}_ERROR`:
      return {
        ...state,
        isReferralQuoteLoading: false
      };

    case `${INSURANCE_QUOTE_FETCH}_SUCCESS`:
      return {
        ...state,
        rootQuoteIsLoading: false,
        insuranceRootQuote: payload
      };

    case `${INSURANCE_QUOTE_FETCH}_LOADING`:
      return {
        ...state,
        rootQuoteIsLoading: true
      };

    case `${INSURANCE_QUOTE_FETCH}_ERROR`:
      return {
        ...state,
        rootQuoteIsLoading: false,
        rootQuoteFetchFailed: true
      };

    case `${INSURANCE_CUSTOMER_CONSENT_FETCH}_SUCCESS`:
      return {
        ...state,
        customerConsent: payload
      };

    case `${INSURANCE_PROFILE_FETCH}_SUCCESS`:
      return {
        ...state,
        insuranceProfile: payload
      };

    case `${INSURANCE_PROGRESSIVE_RC1_QUOTE_FETCH}_LOADING`:
      return {
        ...state,
        progressiveQuote: {
          loading: true,
          hasErrors: insuranceState.progressiveQuote.hasErrors,
          partnerUrl: insuranceState.progressiveQuote.partnerUrl,
          rates: insuranceState.progressiveQuote.rates
        }
      };

    case `${INSURANCE_PROGRESSIVE_RC1_QUOTE_FETCH}_ERROR`:
      return {
        ...state,
        progressiveQuote: {
          loading: insuranceState.progressiveQuote.loading,
          hasErrors: true,
          partnerUrl: insuranceState.progressiveQuote.partnerUrl,
          rates: insuranceState.progressiveQuote.rates
        }
      };

    case `${INSURANCE_PROGRESSIVE_RC1_QUOTE_FETCH}_SUCCESS`:
      return {
        ...state,
        progressiveQuote: {
          loading: insuranceState.progressiveQuote.loading,
          hasErrors: insuranceState.progressiveQuote.hasErrors,
          partnerUrl: payload.url,
          rates: payload.rates
        }
      };

    case `${INSURANCE_POLICY_FETCH}_LOADING`:
      return {
        ...state,
        policyInformation: {
          loading: true,
          status: insuranceState.policyInformation.status
        }
      };

    case `${INSURANCE_POLICY_FETCH}_ERROR`:
      return {
        ...state,
        policyInformation: {
          loading: insuranceState.policyInformation.loading,
          status: insuranceState.policyInformation.status
        }
      };

    case `${INSURANCE_POLICY_FETCH}_SUCCESS`:
      return {
        ...state,
        policyInformation: {
          loading: insuranceState.policyInformation.loading,
          status: payload.status
        }
      };

    case UNSUPPORTED_DOCUMENT_SELECTED:
      return {
        ...state,
        fileSelectionStatus: {
          isValid: false,
          errorMessage: payload
        }
      };

    case RESET_UNSUPPORTED_DOCUMENT_SELECTED:
      return {
        ...state,
        fileSelectionStatus: {
          isValid: true,
          errorMessage: null
        }
      };

    case `${TOGGLE_SHOW_SAMPLE_DOCUMENTS}`:
      return {
        ...state,
        showSampleDocs: payload
      };

    case `${INSURANCE_VALIDATE_POI}_LOADING`:
      return {
        ...state,
        poiValidation: {
          ...state.poiValidation,
          loading: true
        }
      };

    case `${INSURANCE_VALIDATE_POI}_ERROR`:
      return {
        ...state,
        poiValidation: {
          ...state.poiValidation,
          loading: false,
          isSatisfied: false,
          error: 'Failed to parse selected document',
          validationErrors: {
            errorMessages: [],
            duplicateErrors: []
          }
        }
      };

    case `${INSURANCE_VALIDATE_POI}_SUCCESS`: {
      const { isSatisfied, failureTypes } = payload;
      const { errorMessages } = state.poiValidation.validationErrors;

      const formattedErrors = operations.formatErrors(failureTypes);
      const duplicateErrors = operations.buildMatchingErrorArray(
        formattedErrors,
        errorMessages
      );

      return {
        ...state,
        poiValidation: {
          loading: false,
          error: null,
          isSatisfied,
          validationErrors: {
            errorMessages: formattedErrors,
            duplicateErrors: duplicateErrors
          }
        }
      };
    }

    default:
      return {
        ...state
      };
  }
}
